module.exports = __webpack_public_path__ + "img/translate-icon-purple.83ae3511.svg";